import { useRef, useEffect } from 'react';
import { v4 as uuidv4 } from 'uuid';

export default function ChunkInfiniteScroll({Component, items, cancel, callback, advertise, pinnedItems = [], ...props}) {
    const trigger = useRef(null);
    const normalizedPinnedItems = Object.values(pinnedItems).filter((item) => item?.item?.id != null);

    useEffect(() => {
        if (!items.length || cancel) {
            return;
        }
        const currentTrigger = trigger.current;

        const options = {
            root: null,
            rootMargin: "20px",
            threshold: 0.1
        };
        const handleObserver = (entities) => {
            const target = entities[0];
            if (target.isIntersecting) {
                observer.unobserve(trigger.current);
                callback();
            }
        }
        const observer = new IntersectionObserver(handleObserver, options);
        if (trigger.current) {
            observer.observe(trigger.current)
        }

        return () => observer.unobserve(currentTrigger);
    }, [items, cancel]);
    const excludeItems = normalizedPinnedItems.map((item) => item.item.id);

    return (
        <>
            { normalizedPinnedItems.sort((a, b) => {
                return (a.position ?? Number.MAX_SAFE_INTEGER) - (b.position ?? Number.MAX_SAFE_INTEGER);
            }).map(item => <Component key={uuidv4()} isPinned={true} item={item.item} {...props} />) }
            { items
                .map((item, index) => {
                    if (!item || (item.id != null && excludeItems.includes(item.id))) {
                        return null;
                    }
                    if (advertise && advertise.position === index + 1) {
                        return (
                            <>
                                {advertise.item}
                                <Component key={uuidv4()} item={item} {...props} />
                            </>
                        );
                    }
                    return (
                        <Component key={uuidv4()} item={item} {...props} />
                    );
                })
            }
            { items.length !== 0 && <div ref={trigger}/> }
        </>
    )
}
